import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "container" }

import { withDefaults, watch } from 'vue';
import { Column } from '@antv/g2plot';
import type { LiveChartType } from '../types';


const __default__ = {
  name: 'LiveChar',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    dataSource: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { dataSource: LiveChartType[] };


const charRender = () => {
  const columnPlot = new Column('container', {
    data: props.dataSource,
    xField: 'type',
    yField: 'value',
    seriesField: '',
    color: 'l(90) 0:#8FF379 1:#1CBDB4',
    legend: false,
    height: 174,
    minColumnWidth: 20,
    maxColumnWidth: 20,
    columnStyle: {
      // radius: [25, 25, 0, 0],
      cursor: 'pointer',
    },
    xAxis: {
      label: {
        autoHide: true,
        autoRotate: false,
        formatter(text) {
          // 字符太长添加省略号
          return text.length > 3 ? `${text.slice(0, 2)}...` : text;
        },
      },
    },
    yAxis: {
      grid: {
        line: {
          style: {
            lineWidth: 1, // 线宽度
            lineDash: [4, 5], // 虚线配置 [每个分段的长度,分段间隔的距离]
          },
        },
      },
    },
    meta: {
      //   type: {
      //     alias: "类别",
      //   },
      value: {
        alias: '观看量',
      },
    },
  });

  columnPlot.render();
};
watch(props.dataSource, () => {
  charRender();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})